var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    { staticClass: "dm-advanced-search-form", attrs: { action: "/search" } },
    [
      _c(
        "div",
        {
          staticClass: "dm-advanced-search-select dm-hide-mobile-flex",
          class: { "dm-hide-desktop": _vm.isVisible }
        },
        [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "bookCategory" } }, [
                _vm._v("Categories")
              ]),
              _vm._v(" "),
              _c("v-select", {
                class: { disabled: !_vm.categoryEnabled },
                attrs: {
                  taggable: "",
                  options: _vm.taxonomies.categories,
                  disabled: !_vm.categoryEnabled,
                  label: "name",
                  placeholder: "Select Category",
                  multiple: ""
                },
                on: {
                  "option:selected": function($event) {
                    return _vm.loadTaxonomies()
                  },
                  "option:deselected": function($event) {
                    return _vm.loadTaxonomies()
                  }
                },
                model: {
                  value: _vm.search.categories,
                  callback: function($$v) {
                    _vm.$set(_vm.search, "categories", $$v)
                  },
                  expression: "search.categories"
                }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "hidden", name: "categories" },
                domProps: { value: _vm.actuallySelectedCategories }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "bookSubCategory" } }, [
                _vm._v("Sub-categories")
              ]),
              _vm._v(" "),
              _c("v-select", {
                attrs: {
                  taggable: "",
                  options: _vm.taxonomies.subcategories,
                  label: "name",
                  placeholder: "Select Sub-categories",
                  multiple: ""
                },
                on: {
                  "option:selected": function($event) {
                    return _vm.loadTaxonomies()
                  },
                  "option:deselected": function($event) {
                    return _vm.loadTaxonomies()
                  }
                },
                model: {
                  value: _vm.search.sub_categories,
                  callback: function($$v) {
                    _vm.$set(_vm.search, "sub_categories", $$v)
                  },
                  expression: "search.sub_categories"
                }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "hidden", name: "sub_categories" },
                domProps: { value: _vm.actuallySelectedSubCategories }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "bookGenre" } }, [_vm._v("Genre")]),
              _vm._v(" "),
              _c("v-select", {
                attrs: {
                  taggable: "",
                  options: _vm.taxonomies.genres,
                  label: "name",
                  placeholder: "Select Genres",
                  multiple: ""
                },
                on: {
                  "option:selected": function($event) {
                    return _vm.loadTaxonomies()
                  },
                  "option:deselected": function($event) {
                    return _vm.loadTaxonomies()
                  }
                },
                model: {
                  value: _vm.search.genres,
                  callback: function($$v) {
                    _vm.$set(_vm.search, "genres", $$v)
                  },
                  expression: "search.genres"
                }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "hidden", name: "genres" },
                domProps: { value: _vm.actuallySelectedGenres }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "bookThemes" } }, [_vm._v("Themes")]),
              _vm._v(" "),
              _c("v-select", {
                attrs: {
                  taggable: "",
                  options: _vm.taxonomies.themes,
                  label: "name",
                  placeholder: "Select Themes",
                  multiple: ""
                },
                on: {
                  "option:selected": function($event) {
                    return _vm.loadTaxonomies()
                  },
                  "option:deselected": function($event) {
                    return _vm.loadTaxonomies()
                  }
                },
                model: {
                  value: _vm.search.themes,
                  callback: function($$v) {
                    _vm.$set(_vm.search, "themes", $$v)
                  },
                  expression: "search.themes"
                }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "hidden", name: "themes" },
                domProps: { value: _vm.actuallySelectedThemes }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "bookAuthors" } }, [
                _vm._v("Authors")
              ]),
              _vm._v(" "),
              _c("v-select", {
                attrs: {
                  taggable: "",
                  options: _vm.taxonomies.authors,
                  label: "name",
                  placeholder: "Select Authors",
                  multiple: ""
                },
                model: {
                  value: _vm.search.authors,
                  callback: function($$v) {
                    _vm.$set(_vm.search, "authors", $$v)
                  },
                  expression: "search.authors"
                }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "hidden", name: "authors" },
                domProps: { value: _vm.actuallySelectedAuthors }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "dm-advanced-search-submit" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.search.keyword,
              expression: "search.keyword"
            }
          ],
          staticClass: "form-control",
          attrs: { type: "text", name: "keyword", placeholder: "Keyword" },
          domProps: { value: _vm.search.keyword },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.search, "keyword", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c("button", { staticClass: "btn dm-btn-padding" }, [_vm._v("Search")])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "dm-advanced-search-reveal dm-hide-desktop text-center mt-4"
        },
        [
          _c(
            "a",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isVisible,
                  expression: "!isVisible"
                }
              ],
              staticClass: "btn btn-sm dm-btn-brand",
              on: {
                click: function($event) {
                  _vm.isVisible = !_vm.isVisible
                }
              }
            },
            [_vm._v("Show Advanced Filters")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isVisible,
                  expression: "isVisible"
                }
              ],
              staticClass: "btn btn-sm dm-btn-brand",
              on: {
                click: function($event) {
                  _vm.isVisible = !_vm.isVisible
                }
              }
            },
            [_vm._v("Hide Advanced Filters")]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }